export enum StatementTransactionStatuses {
    Active = 1,
    Canceled = 2,
    GlPosted = 3,
    Pending = 4,
    Rejected = 5,
}